import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => sessionStorage.getItem(key),
        setItem: (key, value) => sessionStorage.setItem(key, value),
        removeItem: key => sessionStorage.removeItem(key)
      }
    })
  ],
  //while defining new states, add them to the CLEAR_ALL_STATES mutation as well
  state: {
    userInfo: {},
    assessmentId: null,
    invitedCampaignId: undefined,
    campaignId: null,
    token: null,
    refreshToken: null,
    userId: null,
    proctoringModelsLoaded: false,
    tabId: null,
    campaignInfo: null,
    codeVerifier:null,
    userType:null,
    session: null,
    userIntrestData: null,
    mestaCampaignDetails: {},
    pollerId: null,
    campaignMetadata:null,
    sourceUrl: null,
    isBypassed: false,
  },
  getters: {
    isAuthenticated: state => !!state.token,
    token: state => state.token,
    refreshToken: state => state.refreshToken,
    userId: state => state.userId,
    userInfo: state => state.userInfo,
    mestaCampaignDetails: state => state.mestaCampaignDetails,
    getCampaignId: state => state.campaignId,
    isModelLoaded: state => state.proctoringModelsLoaded,
    tabId: state => state.tabId,
    campaignInfo: state => state.campaignInfo,
    codeVerifier:state => state.codeVerifier,
    userType:state => state.userType,
    session:state => state.session,
    userIntrestData: state => state.userIntrestData,
    pollerId: state => state.pollerId,
    campaignMetadata: state => state.campaignMetadata,
    sourceUrl: state => state.sourceUrl,
    isBypassed: state => state.isBypassed,
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
    CLEAR_TOKEN(state) {
      state.token = null;
    },
    SET_REFRESH_TOKEN(state, refreshToken) {
      state.refreshToken = refreshToken;
    },
    CLEAR_REFRESH_TOKEN(state) {
      state.refreshToken = null;
    },
    SET_IS_BYPASSED(state, flag) {
      state.isBypassed = flag;
    },
    CLEAR_IS_BYPASSED(state) {
      state.isBypassed = false;
    },
    SET_USER_ID(state, userId) {
      state.userId = userId;
    },
    CLEAR_USER_ID(state) {
      state.userId = null;
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_CAMPAIGN_ID_FOR_USER(state, campaignId){
      state.userInfo.campaignId = campaignId
    },
    SET_PROCTORING_MODELS_LOADED(state, flag){
      state.proctoringModelsLoaded = flag
    },
    SET_TAB_ID(state, tabId) { // Mutation for setting tab identifier
      state.tabId = tabId;
    },
    CLEAR_TAB_ID(state) { // Mutation for clearing tab identifier
      state.tabId = null;
    },
    SET_CAMPAIGN_INFO(state, campaignInfo) {
      state.campaignInfo = campaignInfo;
    },
    SET_CODE_VERIFIER(state,codeVerifier) {
      state.codeVerifier = codeVerifier;
    },
    SET_USER_TYPE(state,userType){
      state.userType = userType;
    },
    CLEAR_USER_TYPE(state){
      state.userType = null;
    },
    SET_SESSION_KEY(state,session){
      state.session = session;
    },
    SET_MESTA_CAMPAIGN_DETAILS(state, mestaCampaignDetails){
      state.mestaCampaignDetails =  mestaCampaignDetails;
    },
    CLEAR_SESSION_KEY(state){
      state.session = null;
    },
    SET_USER_INTEREST(state, userInterest){
      state.userIntrestData = userInterest;
    },
    CLEAR_USER_INTEREST(state) {
      state.userIntrestData = null;
    },
    CLEAR_ALL_STATES(state) {
        state.userInfo= {};
        state.assessmentId= null;
        state.invitedCampaignId= undefined;
        state.campaignId= null;
        state.token= null;
        state.refreshToken = null;
        state.userId= null;
        state.proctoringModelsLoaded= false;
        state.tabId= null;
        state.campaignInfo= null;
        state.codeVerifier=null;
        state.userType=null;
        state.session= null;
        state.userIntrestData= null;
        state.mestaCampaignDetails= {};
        state.campaignMetadata = null;
        state.sourceUrl = null;
        state.isBypassed = false;
      },
      SET_POLLER_ID(state,pollerId) {
        state.pollerId=pollerId;
      },
      CLEAR_POLLER_ID(state){
        state.pollerId = null;
      },
    SET_CAMPAIGN_METADATA(state, campaignMetadata) {
      state.campaignMetadata = campaignMetadata;
    },
    SET_SOURCE_URL(state, url) {
      state.sourceUrl = url;
    },
    CLEAR_SOURCE_URL(state) {
      state.sourceUrl = null;
    },
  },
  actions: {
    setToken({ commit }, token) {
      commit('SET_TOKEN', token);
    },
    clearToken({ commit }) {
      commit('CLEAR_TOKEN');
    },
    setRefreshToken({ commit }, refreshToken) {
      commit('SET_REFRESH_TOKEN', refreshToken);
    },
    clearRefreshToken({ commit }) {
      commit('CLEAR_REFRESH_TOKEN');
    },
    setIsBypassed({ commit }, flag) {
      commit('SET_IS_BYPASSED', flag);
    },
    clearIsBypassed({ commit }) {
      commit('CLEAR_IS_BYPASSED');
    },
    setUserId({ commit }, userId) {
      commit('SET_USER_ID', userId);
    },
    clearUserId({ commit }) {
      commit('CLEAR_USER_ID');
    },
    setUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo);
    },
    setCampaignId({ commit }, campaignId){
      commit('SET_CAMPAIGN_ID_FOR_USER', campaignId);
    },
    setProctoringModelsLoaded({commit}, flag){
      commit('SET_PROCTORING_MODELS_LOADED', flag)
    },
    setTabId({ commit }, tabId) { // Action for setting tab identifier
      commit('SET_TAB_ID', tabId);
    },
    clearTabId({ commit }) { // Action for clearing tab identifier
      commit('CLEAR_TAB_ID');
    },
    setCampaignInfo({commit}, campaignInfo){
      commit('SET_CAMPAIGN_INFO', campaignInfo)
    },
    clearCampaignInfo({commit}){
      commit('SET_CAMPAIGN_INFO', null)
    },
    setCodeVerifier({commit}){
      commit('SET_CODE_VERIFIER', null)
    },
    setUserType({commit},userType){
      commit('SET_USER_TYPE',userType)
    },
    clearUserType({commit}){
      commit('CLEAR_USER_TYPE')
    },
    setSessionKey({commit},session){
      commit('SET_SESSION_KEY',session)
    },
    clearSessionKey({commit}){
      commit('CLEAR_SESSION_KEY')
    },
    setUserInterest({commit}, userInterest){
      commit('SET_USER_INTEREST', userInterest)
    },
    setMestaCampaignDetails({commit}, mestaCampaignDetails){
      commit('SET_MESTA_CAMPAIGN_DETAILS', mestaCampaignDetails)
    },
    clearUserInterest({commit}){
      commit('CLEAR_USER_INTEREST')
    },
    clearAllStates({commit}){
      commit('CLEAR_ALL_STATES')
    },
    setPollerId({commit}, pollerId){
      commit('SET_POLLER_ID',pollerId)
    },
    clearPollerId({commit}){
      commit('CLEAR_POLLER_ID')
    },
    setCampaignMetadata({commit}, campaignMetadata){
      commit('SET_CAMPAIGN_METADATA', campaignMetadata);
    },
    setSourceUrl({commit}, url){
      commit('SET_SOURCE_URL', url);
    },
    clearSourceUrl({commit}){
      commit('CLEAR_SOURCE_URL');
    },
  },
  modules: {
  },
});
